import { Head } from "@inertiajs/react"
import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"

interface PartnerBranding {
  name: string
  logo_url: string | null
  logo_wordmark_url: string | null
}

// IMP-267: partner-scoped legal document (Terms of Service / Privacy Policy).
// Standalone public page, branded by the partner header when on a subdomain.
export default function LegalDocument({
  title,
  body,
  partner,
}: {
  title: string
  body: string
  version: string
  partner: PartnerBranding | null
}) {
  const brandName = partner?.name ?? "Imperative"
  const logoSrc = partner?.logo_wordmark_url ?? partner?.logo_url ?? null

  return (
    <div className="bg-muted/30 min-h-svh">
      <Head title={title} />
      <div className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 flex items-center gap-3">
          {logoSrc ? (
            <img
              src={logoSrc}
              alt={brandName}
              className="h-8 w-auto object-contain"
            />
          ) : (
            <span className="text-base font-semibold text-zinc-900">
              {brandName}
            </span>
          )}
        </header>

        <article className="prose prose-zinc max-w-none rounded-xl border bg-white p-8 shadow-sm">
          {/* remark-gfm: render the legal docs' tables + autolink bare URLs */}
          <Markdown remarkPlugins={[remarkGfm]}>{body}</Markdown>
        </article>
      </div>
    </div>
  )
}
